import { render } from "./Sardine.vue?vue&type=template&id=6ebd0ec6&scoped=true"
import script from "./Sardine.vue?vue&type=script&lang=js"
export * from "./Sardine.vue?vue&type=script&lang=js"

import "./Sardine.vue?vue&type=style&index=0&id=6ebd0ec6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ebd0ec6"]])

export default __exports__